import { QueryClient } from '@tanstack/react-query'
import { EnvironmentKey } from 'vite-env'

import queryKeys from 'Common/queryKeys/queryKeys'
import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

import { environments } from '../../config'
import { Environment, ServiceKey } from './types'

const queryClient = new QueryClient()

export const getEnvironment = async () => {
    try {
        const fetchConfig = await fetch('/config')
        const config: Environment = await fetchConfig.json()
        return config
    } catch (e) {
        if (import.meta.env.VITE_CLIENT_ENV) {
            // To keep parity between development and live environments this is placed here
            return environments[import.meta.env.VITE_CLIENT_ENV as EnvironmentKey]
        }
        console.error('Environment not loaded.')
        throw e
    }
}

const wrapServiceAsync = (serviceKey: ServiceKey) => async (uri: string) => {
    const env = await queryClient.fetchQuery({
        queryKey: [queryKeys.environment],
        queryFn: getEnvironment,
        staleTime: RequestStaleTime.configuration,
    })
    return `${env.endpoints[serviceKey]}${uri}`
}

export const servicesAsync = {
    assets: wrapServiceAsync('assets'),
    calculation: wrapServiceAsync('calculation'),
    concept: wrapServiceAsync('concept'),
    contact: wrapServiceAsync('contact'),
    distribution: wrapServiceAsync('distribution'),
    externalApi: wrapServiceAsync('externalApi'),
    identity: wrapServiceAsync('identity'),
    identityserver: wrapServiceAsync('identityserver'),
    metadata: wrapServiceAsync('metadata'),
    profitability: wrapServiceAsync('profitability'),
    royalty: wrapServiceAsync('royalty'),
    schilling: wrapServiceAsync('schilling'),
    storage: wrapServiceAsync('storage'),
    users: wrapServiceAsync('users'),
    webhook: wrapServiceAsync('webhook'),
    work: wrapServiceAsync('work'),
}
